import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  data() {
    return {
      audiencNumber: 0,
      audienceList: [],
      loadList: false
    };
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    movePips: {
      type: Object,
      default: () => {
        return {};
      }
    },
    questionerList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tagNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.loadList = true;
    this.getOnlineMember();
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.audienceList.forEach(inVal => {
            if (inVal.rtilCode == val.mark) {
              inVal.nickName = val.value;
            }
          });
        } else if (val.key === 'organization') {
          this.audienceList.forEach(inVal => {
            if (inVal.rtilCode == val.mark) {
              inVal.organization = val.value;
            }
          });
        }
      });
    });
    Bus.$on('setSpeaker', v => {
      this.getOnlineMember();
    });
    Bus.$on('cancelSpeaker', v => {
      this.getOnlineMember();
    });
    Bus.$on('cancelQuestioner', v => {
      this.getOnlineMember();
    });
    Bus.$on('setQuestionSpeaker', async v => {
      this.getOnlineMember();
    });
    Bus.$on('cancelQuestionSpeaker', v => {
      this.getOnlineMember();
    });
  },
  computed: {
    ...mapState({
      State: state => state,
      PrivateInfo: state => state.privateInfo
    }),
    participantsOperateList() {
      const obj = {};
      this.audienceList.forEach(v => {
        // this.reporterList里面会包含speaker和talker ???
        if (v.rtilCode == this.userInfo.rtilCode) {
          obj[v.rtilCode] = ['rename', 'addQuestioner'];
        } else {
          if (this.State.privateInfo.rtilCode == v.rtilCode) {
            obj[v.rtilCode] = ['editTagName', 'addQuestioner', 'cancelPrivateConversation', {
              key: 'roleSetting',
              children: ['setSpeaker', 'audience']
            }, 'moveParty', 'removeParticipant'];
          } else {
            // 判断是否为anywhere，因为anywhere不能设置成speaker
            if (v.excludeSpeakerCandidate) {
              obj[v.rtilCode] = ['editTagName', 'addQuestioner', 'startPrivateConversation', 'moveParty', 'removeParticipant'];
            } else {
              obj[v.rtilCode] = ['editTagName', 'addQuestioner', 'startPrivateConversation', 'moveParty', {
                key: 'roleSetting',
                children: ['setSpeaker', 'audience']
              }, 'removeParticipant'];
            }
          }
          obj[v.rtilCode].unshift('rename');
        }
      });
      return obj;
    }
  },
  methods: {
    getOnlineMember() {
      this.axios.get(`/partyline-backend/conference/onlineMembers/${this.State.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          this.loadList = false;
          this.audienceList = res.data.result[2] || [];
          if (this.showLocal()) {
            var _this$userInfo$behavi, _this$userInfo$behavi2;
            this.audienceList.unshift({
              nickName: (_this$userInfo$behavi = this.userInfo.behavior) === null || _this$userInfo$behavi === void 0 ? void 0 : _this$userInfo$behavi.nickName,
              rtilCode: this.userInfo.rtilCode,
              organization: (_this$userInfo$behavi2 = this.userInfo.behavior) === null || _this$userInfo$behavi2 === void 0 ? void 0 : _this$userInfo$behavi2.organization
            });
          }
        }
      });
    },
    callback(obj) {
      this.$emit('callback', obj);
    },
    moveParty(val, rtilCode) {
      this.$emit('callback', {
        type: 'moveParty',
        id: rtilCode,
        status: val,
        sign: 'batch'
      });
    },
    showLocal() {
      let flag = true;
      // 如果 host 是 speaker 或者 talker 都不在列表里显示
      if (this.State.speakerInfo && this.State.speakerInfo.rtilCode == this.userInfo.rtilCode || this.State.talkInfo && this.State.talkInfo.rtilCode == this.userInfo.rtilCode) {
        flag = false;
      }
      this.questionerList.forEach(item => {
        if (item.rtilCode == this.userInfo.rtilCode) {
          flag = false;
        }
      });
      return flag;
    },
    changeAudience(info, type) {
      if (type === 'add') {
        let flag = true;
        this.audienceList.forEach(v => {
          if (v.rtilCode == info.rtilCode) {
            flag = false;
          }
        });
        if (flag) this.audienceList.push(info);
      } else {
        this.audienceList.forEach((v, i) => {
          if (v.rtilCode == info.rtilCode) {
            this.audienceList.splice(i, 1);
          }
        });
      }
    }
  }
};